<template>
  <div>
    <Head title="Routes" />
    <h1 class="text-3xl font-bold mb-5">
      <Link class="text-sky-400 hover:text-sky-600" href="/routes">Rutas</Link>
      <span class="text-sky-400 font-medium">/</span>
      {{ route.description }}
    </h1>
    <div class="bg-white rounded-md shadow max-w-2xl">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">          
          <th class="pb-4 pt-6 px-5">Día</th>
          <th class="pb-4 pt-6 px-2">#Clientes</th>
          <th class="pb-4 pt-6 px-2">Agregar cliente</th>
          <th class="pb-4 pt-6 px-2">Descuentos</th>
          <th class="pb-4 pt-6 px-2">Precios</th>
        </tr>
        <tr v-for="day_route in days_route" :key="day_route.id" class="hover:bg-gray-100 focus-within:bg-gray-100">          
          <td class="border-t p-5">
            {{ day_route.day_name }}
          </td>
          <td class="border-t p-5">
            {{ day_route.total_clients }}
          </td>
          <td class="border-t">
            <button class="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2" @click="goToClients(route.id,day_route.id_day)">
              Asignar Cliente                         
            </button>
          </td>

          <td class="border-t">
            <button class="text-white bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2" @click="showDialogDiscountList(route.id,day_route.id_day, day_route.day_name)">
              Descuentos                        
            </button>
          </td>

          <td class="border-t text-center">
            <button type="button" class="text-white bg-gradient-to-r from-violet-400 via-violet-500 to-violet-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-violet-300 dark:focus:ring-violet-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2" @click="showDialogPriceList(day_route.id_day, route.id, day_route.day_name)">Lista de precios</button>
          </td>
        </tr>
      </table>
    </div>
    <div>
      <DialogInput v-if="showDialogInput" v-model="dialogValue" label="Nombre" :title="'Crear ruta'" @close="closeDialog">     
        <form class="w-full max-w-sm py-2" @submit.prevent="store">
          <div>
            <text-input v-model="form.code" class="py-2 w-full" label="Código" />            
            <text-input v-model="form.description" class="py-2 w-full" label="Descripcion" />
          </div>
          <div class="flex items-center justify-center px-8 py-4">          
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear</loading-button>
          </div>
          <span class="text-sm justify-end">Los clientes para las rutas podras agregarlos más adelante</span>
        </form>
      </DialogInput>
    </div>
    <div>
      <DialogInput v-if="showDialogAddEmployee" label="Nombre" :title="'Encargados'" @close="showDialogAddEmployee = false">     
        <form class="w-full max-w-sm py-2" @submit.prevent="store">
          <div>
            <text-input v-model="form.code" class="py-2 w-full" label="Código" />            
            <text-input v-model="form.description" class="py-2 w-full" label="Descripcion" />
          </div>
          <div class="flex items-center justify-center px-8 py-4">          
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear</loading-button>
          </div>
          <span class="text-sm justify-end">Los clientes para las rutas podras agregarlos más adelante</span>
        </form>
      </DialogInput>
    </div>

    <div style="width: 100px;">
      <DialogInput v-if="dialogDiscountList" label="Descuentos" :title="'Agregar descuento'" @close="dialogDiscountList = false">      
        <form class="  py-2" @submit.prevent="storeDiscountListoToRoute">
          <div class=" ">          
            <p class="text-lg">Dia: <span class="font-medium">{{ description }}</span> </p>
            <Multiselect
              v-model="selectedDiscount"
              placeholder="Seleciona una o varias opciones"                      
              :options="listDiscounts.map(discount => ({ value: discount.id, label: discount.name }))" 
              mode="tags"
              :close-on-select="false"
              :searchable="true"
            /> 
          </div>
          <div class="flex items-center justify-center px-8 py-4">          
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Agregar</loading-button>
          </div>
        </form>
        <p class="text-sm justify-end">El <strong>descuento</strong> se asignará a todos los clientes de la sub-ruta seleccionada.<br>  Si después de esta asignación se añade un nuevo cliente,  será necesario<br> actualizar la lista. Esto se puede hacer <strong>repitiendo</strong> el mismo proceso o  <br>individualmente desde el apartado de clientes.</p>
      </DialogInput>
    </div>

    <div>
      <DialogInput v-if="dialogPriceList" label="Precios" :title="'Agregar lista de precios'" @close="dialogPriceList = false">      
        <form class="w-full max-w-sm py-2" @submit.prevent="storePriceListToRoute">
          <div>          
            <p class="text-lg">Ruta: <span class="font-medium">{{ description }}</span> </p>
            <Multiselect
              v-model="listPriceSelected"
              placeholder="Seleciona una o varios precios"                      
              :options="listPrices.map(price => ({ value: price.id, label: price.description }))" 
              mode="tags"
              :close-on-select="false"
              :searchable="true"
            /> 
          </div>
          <div class="flex items-center justify-center px-8 py-4">          
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Agregar</loading-button>
          </div>
          <span class="text-sm justify-end">La lista de precios se asignará a todos los clientes de la ruta seleccionada. Si después de esta asignación se añade un nuevo cliente, será necesario actualizar la lista. Esto se puede hacer repitiendo el mismo proceso o individualmente desde el apartado de clientes.</span>
        </form>
      </DialogInput>
    </div>
  </div>
</template>
    
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import DialogInput from '@/Shared/Dialog'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Link,
    DialogInput,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {    
    days_route: Array,
    route: Object,
    listDiscounts: Array,  
    listPrices: Array,
  },
  remember: 'form',
  data() {
    return {     
      form: this.$inertia.form({
        code:'',
        description:'',
        estatus:'',
      }),

      formDiscount: this.$inertia.form({
        id_day:'',
        id_route: '',
        listDiscounts:'',
        listPrices: '',
      }),
      dialogValue: '',
      showDialogInput: false,
      showDialogAddEmployee: false,
      selectedOption: null, 
      id_route: 0,
      id_day: 0, 
      dialogDiscountList: false,
      selectedDiscount: null,  
      dialogPriceList: false,
      description: '',
      listPriceSelected: [],
    }
  },
  watch: {
  //   form: {
  //     deep: true,
  //     handler: throttle(function () {
  //       this.$inertia.get('/routes', pickBy(this.form), { preserveState: true })
  //     }, 150),
  //   },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    goToClients(routeId, day) {
      window.location.href = `/routes/${routeId}/sub-routes/${day}`
    },  
    goToEmployee(routeId) {
      window.location.href = `/routes/${routeId}/employee`
    },  
    store() {
      (async () => {
        try {
          await this.$inertia.post('/routes', this.form)
          // Si la respuesta es exitosa, puedes agregar aquí cualquier lógica adicional
          this.closeDialog()
        } catch (error) {
          console.error('Error al enviar datos:', error)
          // Puedes manejar el error aquí si es necesario
        }
      })()
    },
    

    showDialog() {
      this.showDialogInput = true 
    },
    closeDialog() {
      this.showDialogInput = false 
    },   
    showDialogDiscountList(routeId, dayId, description) {
      this.dialogDiscountList = true
      this.idRoute = routeId
      this.description = description
      this.id_day = dayId
      console.log(`la ruta es: ${routeId}`)
    },
    storeDiscountListoToRoute() {
      this.$inertia.post('/add_discount_to_route', {
        idRoute: this.idRoute,
        idDay: this.id_day,
        selectedDiscount: this.selectedDiscount,
      }, {
        onSuccess: () => {
          console.log('Petición exitosa')
          this.selectedDiscount = null
          this.dialogDiscountList = false
        },
        onError: (errors) => {
          console.error('Error al enviar datos:', errors)
        },
      })
    },
    showDialogPriceList(idDay, routeId, description) {
      this.dialogPriceList = true
      this.idRoute = routeId
      this.idDay = idDay
      this.description = description
    },
    storePriceListToRoute() {
      this.$inertia.post('/add_price_list_to_route', {
        idRoute: this.idRoute,
        selectedOption: this.listPriceSelected,
        idDay: this.idDay,
      }, {
        onSuccess: () => {
          console.log('Petición exitosa')
          this.listPriceSelected = []
          this.dialogPriceList = false
        },
        onError: (errors) => {
          console.error('Error al enviar datos:', errors)
        },
      })
    },
  },
}
</script>  
<style src="@vueform/multiselect/themes/default.css"></style>